export const LANGUAGES = [
  { code: "Italian", label: "Italiano", flag: "🇮🇹" },
  { code: "English", label: "English", flag: "🇬🇧" },
  { code: "Spanish", label: "Español", flag: "🇪🇸" },
  { code: "French", label: "Français", flag: "🇫🇷" },
  { code: "German", label: "Deutsch", flag: "🇩🇪" },
  { code: "Portuguese", label: "Português", flag: "🇵🇹" },
  { code: "Dutch", label: "Nederlands", flag: "🇳🇱" },
  { code: "Russian", label: "Русский", flag: "🇷🇺" },
  { code: "Chinese", label: "中文", flag: "🇨🇳" },
  { code: "Japanese", label: "日本語", flag: "🇯🇵" },
  { code: "Korean", label: "한국어", flag: "🇰🇷" },
  { code: "Arabic", label: "العربية", flag: "🇸🇦" },
  { code: "Hindi", label: "हिन्दी", flag: "🇮🇳" },
  { code: "Turkish", label: "Türkçe", flag: "🇹🇷" },
  { code: "Polish", label: "Polski", flag: "🇵🇱" },
];

export const SOURCE_LANGUAGES = [{ code: "auto", label: "Rileva lingua", flag: "✨" }, ...LANGUAGES];

export const TONES = [
  { code: "natural", label: "Naturale (madrelingua)", pro: false },
  { code: "formal", label: "Formale", pro: true },
  { code: "technical", label: "Tecnico", pro: true },
  { code: "colloquial", label: "Colloquiale", pro: true },
  { code: "copywriter", label: "Copywriter / Marketing", pro: true },
  { code: "academic", label: "Accademico", pro: true },
];
